<template>
  <div>
    <!-- aplicamos top y height dinámicos para evitar solapamiento -->
    <v-overlay
      v-model="dialogVisibility"
      :color="overlayColor"
      opacity="0.92"
      :style="{ top: `${appBarHeight}px`, height: `calc(100vh - ${appBarHeight}px)` }"
    >
      <v-container @keydown.enter="confirm">
        <v-row class="pa-10 text-center">
          <div v-if="error" class="col-sm-1 col-md-3"></div>
          <div v-if="error" class="col-sm-10 col-md-6">
            <v-alert class="mt-5 red" border="left" text>
              {{ errorMsg }}
            </v-alert>
          </div>

          <div class="col-12" :style="{ color: textColor }">
            {{ $t("please_tell_us_your_ID_to_sign.", { id: typeOfId }) }}
          </div>

          <div class="offset-md-4 col-md-4 col-sm-12">
            <input
              type="text"
              id="custom-input"
              v-model="citizenId"
              :placeholder="$t('_id')"
              @input="citizenId = $event.target.value.toUpperCase()"
              class="txt-uppercase"
              v-uppercase
            />
          </div>

          <div class="col-12">
            <v-btn
              :color="buttonColor"
              :style="{ color: buttonTextColor }"
              @click="confirm()"
              :disabled="!citizenId"
              depressed
              class="mt-3"
              min-width="96"
            >
              {{ $t("ok") }}
            </v-btn>
          </div>
        </v-row>
      </v-container>
    </v-overlay>
  </div>
</template>

<script>
import { SignaturesService } from "../../services/signatures-service";

export default {
  name: "access-modal",

  props: ["dialog", "documentId", "documentToken", "typeOfId"],

  data: function () {
    return {
      citizenId: null,
      error: false,
      errorMsg: "",
      loading: false,
      dialogVisibility: false,
      appBarHeight: 0, // altura calculada de la appBar
    };
  },

  watch: {
    dialog(val) {
      this.dialogVisibility = val;

      if (val) {
        // cada vez que se abre, recalculamos la altura (por si cambió)
        this.computeAppBarHeight();
        this.onDialogOpened();
      }
    },
  },

  mounted() {
    // recalcula al montar y cuando se redimensione la ventana
    this.computeAppBarHeight();
    window.addEventListener("resize", this.computeAppBarHeight);

    console.log("OverlayColor al montar AccessModal:", this.overlayColor);
    console.log("Botón: " + this.buttonColor);
    console.log("Texto Botón: " + this.buttonTextColor);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.computeAppBarHeight);
  },

  computed: {
    requestId() {
      return this.isAuthCitizenId ? this.$store.state.common.requestId : this.documentId;
    },
    isAuthCitizenId() {
      return this.$route.query.auth && this.$route.query.auth == "citizenid" ? true : false;
    },
    hasAssociation() {
      return this.$store.getters["common/hasAssociation"];
    },
    overlayColor() {
      return this.$store.state.common.footerColor;
    },
    buttonColor() {
      return this.$store.state.common.buttonColor;
    },
    buttonTextColor() {
      return this.$store.state.common.buttonTextColor;
    },
    textColor() {
          return this.$store.state.common.footerTextColor;
        },
    appBarTextColor() {
      return this.$store.state.common.appBarTextColor;
    },
  },

  methods: {
    onDialogOpened() {
      console.log("🧩 overlayColor:", this.overlayColor);
      // aquí pones la lógica que necesitas cuando el modal se hace visible
    },

    // calcula la altura de la appBar (busca elementos comunes de app-bar)
    computeAppBarHeight() {
      // ajusta el selector si tu appBar tiene otra clase/id
      const selectors = [".v-app-bar", ".app-bar", "header.v-toolbar", "header"];
      let el = null;
      for (const sel of selectors) {
        el = document.querySelector(sel);
        if (el) break;
      }
      const fallback = 64; // valor por defecto si no encuentra elemento
      const height = el ? Math.round(el.getBoundingClientRect().height) : fallback;
      this.appBarHeight = height;
    },

    confirm() {
      this.error = false;
      this.errorMsg = "";
      this.currentAssociation = localStorage.getItem("currentAssociation");
      if (this.citizenId) {
        SignaturesService.getSignatureRequestDataAuth(
          this.requestId,
          this.citizenId,
          this.isAuthCitizenId,
          this.documentToken
        )
          .then((response) => {
            this.error = false;
            this.loading = false;

            if (response.data.signerId && response.data.signerId.id == this.citizenId) {
              this.$store.dispatch("common/addAuthId", this.citizenId).then((response) => {
                if (response) {
                  this.$emit("closeModal");

                  let listValue = localStorage.getItem("list");
                  if (listValue === "true") {
                    console.log("hasAssociation: " + this.hasAssociation);

                    let routeName = this.hasAssociation ? "custom-multiple-pdf" : "multiple-pdf";
                    let routeParams = this.hasAssociation ? { association: this.currentAssociation } : {};

                    setTimeout(() => {
                      this.$router.push({
                        name: routeName,
                        params: routeParams,
                        query: { token: this.documentToken },
                      });
                    }, 300);
                  }
                }
              });
            } else {
              this.error = true;
              this.errorMsg = this.$t("invalid_auth_id");
            }
          })
          .catch((error) => {
            this.loading = false;
            if (error.response && error.response.status == 403) {
              this.error = true;
              this.errorMsg = error.response.data.description;
            }
          });
      }
    },

    async checkForNextStep() {
      let documentCheckList = localStorage.getItem("documentCheckList")
        ? JSON.parse(localStorage.getItem("documentCheckList"))
        : [];

      documentCheckList.forEach((document, index) => {
        documentCheckList[index].checkId = false;
        documentCheckList[index].idChecked = true;
      });

      localStorage.setItem("documentCheckList", JSON.stringify(documentCheckList));

      for (const document of documentCheckList) {
        if (document.checkAttachments && !document.attachmentsChecked) {
          this.$router.push({
            name: `${this.hasAssociation ? "custom-" : ""}attachments`,
            params: { id: document.documentId },
            query: this.$route.query,
          });
          break;
        }
      }
    },
  },
};
</script>
